import { render, staticRenderFns } from "./transportOrderAdd.vue?vue&type=template&id=602fc3a4&scoped=true"
import script from "./transportOrderAdd.vue?vue&type=script&lang=js"
export * from "./transportOrderAdd.vue?vue&type=script&lang=js"
import style0 from "./transportOrderAdd.vue?vue&type=style&index=0&id=602fc3a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602fc3a4",
  null
  
)

export default component.exports